import { DEFAULT_GC_TIME, DEFAULT_STALE_TIME } from '@/client/constants';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import useGetQueryFn from '../use-get-query-fn';

export interface ConversationWindowItem {
  phone: string;
  last_inbound_at: number;
  expires_in_seconds: number;
}

type QueryResponse = {
  status: number;
  data: {
    windows: ConversationWindowItem[];
    total_count: number;
    limit: number;
    offset: number;
  };
};

export const createListConversationWindowsKey = (additional: any[] = []) => [
  'list-conversation-windows',
  ...additional,
];

export const useListConversationWindowsQuery = (additionalProps = {}) => {
  const queryFn = useGetQueryFn<QueryResponse>({
    defaultErrorMessage: 'An unexpected error occurred while listing conversation windows',
    endpoint: `/api/admin/whatsapp/windows`,
  });

  return useQuery({
    queryKey: createListConversationWindowsKey([additionalProps]),
    queryFn: () => queryFn({ ...additionalProps }),
    staleTime: DEFAULT_STALE_TIME,
    gcTime: DEFAULT_GC_TIME,
    placeholderData: keepPreviousData,
  });
};
